import { render, staticRenderFns } from "./Tema1.vue?vue&type=template&id=c70ac308&scoped=true&lang=pug&"
import script from "./Tema1.vue?vue&type=script&lang=js&"
export * from "./Tema1.vue?vue&type=script&lang=js&"
import style0 from "./Tema1.vue?vue&type=style&index=0&id=c70ac308&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70ac308",
  null
  
)

export default component.exports